import VerificationApi from "../services/verificationApi";
import { apiErrorResponse, authorizationError } from '../helper/constant';
import { put } from 'redux-saga/effects'
import { INIT_SET_USER_RESPONSE, INIT_SET_USER_FAIL } from '../redux/types/user';
import { SET_LOADING, CLEAR_LOADING } from '../redux/types/loader';
import { setUser } from "../redux/actions/user";
import { RESPONSE_ERROR_SNACK_OPEN, RESPONSE_ERROR_POPUP } from '../redux/types/responseError'
import { push } from "connected-react-router";
import LogoutApi from '../services/logout'

let api = new VerificationApi();
let logoutApi = new LogoutApi();

export function* verifyOtpEmail({ type, payload, resolve, reject }) {
    try {
        let responsePayload = {};
        let response = yield api.verifyOtpEmail(payload)
        if (response && response.data.Status) {
            if (response.data.Data.Status === '1') {
                yield put(setUser({ isOtpRequired: false }))
            }
            resolve(response.data.Data);
        } else {
            yield put({ type: CLEAR_LOADING })
            responsePayload = { type: "error", message: response.data.Message }
            yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
        }
    } catch (e) {
        yield put({ type: CLEAR_LOADING })
        let responsePayload = {};
        responsePayload = { type: "error", message: apiErrorResponse }
        yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
    }
}

export function* getSchemeDetails({ type, payload, resolve, reject }) {
    try {
        let response = yield api.getSchemeDetails(payload)
        if (response.data && response.data.Status) {
            resolve(response.data.Data);
        } else {
            reject({ message: response.data.Message });
        }
    } catch (e) {
        yield put({ type: CLEAR_LOADING })
        let responsePayload = {};
        responsePayload = { type: "error", message: apiErrorResponse }
        yield put({ type: RESPONSE_ERROR_SNACK_OPEN, payload: responsePayload })
    }
}

export function* resendOtp({ type, payload, resolve, reject }) {
    try {
        let response = yield api.resendOtp(payload)
        console.log('response.data', response.data)
        console.log('response.data', response.data.Data)
        if (response.data && response.data.Status) {
            if (response.data.Data) {
                resolve(response.data.Data);
            } else {
                reject({ message: response.data.Data.Message });
            }
        }
        else {
            reject({ message: response.data.Message });
        }
    } catch (e) {
        reject({ message: apiErrorResponse })
    }
}

export function* initSetUser({ type, payload, resolve, reject }) {
    yield put({ type: SET_LOADING })
    try {
        let responsePayload = {};
        let output = yield api.initSetUser(payload)
        console.log('init response', output);
        yield put({ type: CLEAR_LOADING })
        let response = output.data || {};
        if (response && response.Status && response.Data && response.Data[0]) {
            // Legacy `data[0].<LEGACY>` unpacks deleted per
            // stage-0-arrival.md §5.5 — fields listed as out-of-scope in
            // §3.3 had no consumer downstream once /dad migrated to
            // journeyApi.status(). Per-stage docs prune the redux slice
            // fields themselves in Phase D. The four fields below are
            // the minimal post-rehydrate writeback for any remaining
            // legacy /app/init caller (NON-DAD, commented out per §6
            // wave 2).
            let data = response.Data;
            responsePayload.id = data[0].USERID;
            responsePayload.applicationType = data[0].APPLICATIONTYPE;
            responsePayload.clientCode = data[0].CLIENTCODE;
            responsePayload.pageName = data[0].PAGENAME;

            yield put({ type: INIT_SET_USER_RESPONSE, payload: responsePayload });
            resolve && resolve(response.Data);
        } else {
            if (response.code === 401) {
                let res = yield logoutApi.logout(payload)
                console.log('res in init', res)
                responsePayload = { open: true }
                yield put({ type: RESPONSE_ERROR_POPUP, payload: responsePayload })
                yield put(push('/'));
            }
            yield put({ type: INIT_SET_USER_FAIL })
        }
    }
    catch (e) {
        console.log(e, 'error');
    }
}

export function* initSetUserSuperApp({ type, payload, resolve, reject }) {
    yield put({ type: SET_LOADING })
    try {
        let responsePayload = {};
        let output = yield api.initSetUserSuperApp(payload)
        console.log('initSetUserSuperApp response', output);
        yield put({ type: CLEAR_LOADING })
        let response = output.data || {};
        if (response && response.Status && response.Data && response.Data[0]) {
            let data = response.Data;
            responsePayload.pageName = data[0].PAGENAME;
            yield put({ type: INIT_SET_USER_RESPONSE, payload: responsePayload });
            resolve && resolve(response.Data[0]);
        } else {
            if (output.code === 401) {
                let res = yield logoutApi.logout(payload)
                console.log('res in init', res)
                responsePayload = { open: true }
                yield put({ type: RESPONSE_ERROR_POPUP, payload: responsePayload })
                yield put(push('/'));
            }
            yield put({ type: INIT_SET_USER_FAIL })
        }

    } catch (e) {
        console.log(e, "error-->")

    }
}

